import React, { Component } from "react";
import EventBus from "eventing-bus";
import { ACTION_TYPES } from "src/constants";
import { Loader, Header } from "src/components";
import { Form, Formik } from "formik";
import moment from "moment";
import { TextInputOne, ButtonOne } from "src/components/form-inputs";
import { Link, withRouter } from "react-router-dom";
import LandingPagesTable from "./landing-pages-table";
import { Container } from "../../../../components";
import styles from "./_landing-pages.module.scss";

class LandingPages extends Component {
  state = {
    isLoading: false,
    pageNumber: 1,
    search: "",
  };

  componentDidMount() {
    this.requestLandingPages = EventBus.on(
      ACTION_TYPES.REQUEST_LANDING_PAGES,
      () => this.setState({ isLoading: true })
    );
    this.requestLandingPagesSuccess = EventBus.on(
      ACTION_TYPES.REQUEST_LANDING_PAGES_SUCCESS,
      this.handleLandingPagesSuccess
    );
    this.requestLandingPagesFailure = EventBus.on(
      ACTION_TYPES.REQUEST_LANDING_PAGES_FAILURE,
      () => this.setState({ isLoading: false })
    );

    this.props.requestLandingPages({page: this.state.pageNumber});
  }

  componentWillUnmount() {
    this.requestLandingPages();
    this.requestLandingPagesSuccess();
    this.requestLandingPagesFailure();
  }

  handleLandingPagesSuccess = () => {

    this.setState({ isLoading: false });
  };

  _handlePaginationChange = (pageNumber) => {
    this.setState(
      {
        pageNumber,
      },
      () =>
        this.props.requestLandingPages({
          page: pageNumber
        })
    );
  };

  handleSearch = (e) => {
    this.setState({ search: e.target.value.toLowerCase() });
  };


  onRowSelected = (data) => {
    this.props.history.push('/admin/landing-pages-create/' + data.uuid)
  }

  render() {
    const { isLoading, search } = this.state;
    const { landingPages } = this.props;
    let regex = new RegExp(search, "i");

    return (
      <div className={styles["one-time-transactions"]}>
        <Header title="Landing Pages" />
        <Container>
          <div className={styles["search-box"]}>
            <Formik initialValues={{ search: "" }}>
              <Form>
                <div className={styles["search-input-box"]}>
                  <TextInputOne
                    name="search"
                    id="search"
                    type="text"
                    value={search}
                    placeholder="Search by landing page name..."
                    onChange={this.handleSearch}
                  />
                  <div className={styles["search-icon"]}>
                    <img src="/img/search.svg" alt="search" />
                  </div>
                </div>
              </Form>
            </Formik>
          </div>

          {<LandingPagesTable
            data={landingPages || []}
            handlePaginationChange={this._handlePaginationChange}
            totalItems={landingPages?.count || 0}
            onRowSelected={this.onRowSelected}
          />}

          <div className={styles["divider"]} />
          <div className={styles["footer"]}>
            <Link to={"/admin/landing-pages-create/new"}>
              <ButtonOne>
                <img
                  src="/img/plusnew.svg"
                  alt="plus"
                  className={styles["plus-btn"]}
                />
                <div>Create new landing page</div>
              </ButtonOne>
            </Link>
          </div>
        </Container>
        <Loader loading={isLoading} />
      </div>
    );
  }
}

export default withRouter(LandingPages);
